module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-shirley-121c5d85b5343f62ecb1e4891bb5375a.jpg";